import { useEffect, useState, useMemo } from "react";
import { Checkbox } from "@pankod/refine-mui";

import { TOKEN_KEY } from "constants";
import axios from "utils/axios";

export default function CheckboxCoupon({
  value,
  disabled = false,
  accommodationID,
  couponID,
  field,
  fromDate,
  toDate,
}) {
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleInputChange = useMemo(() => {
    let timeoutId;

    //a function that delays its execution until after a certain amount of time
    //has passed since the last time it was invoked.
    return function (value) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        let body = {
          accommodationID,
          couponID,
          field,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
          value: value,
        };
        const jwt_token = localStorage.getItem(TOKEN_KEY);
        axios.defaults.headers.common.Authorization = `Bearer ${jwt_token}`;
        axios.put("/api/tableau-coupon", body);
        //console.log("Send body: " + JSON.stringify(body));
      }, 200);
    };
  }, []);

  return (
    <Checkbox
      checked={localValue}
      onChange={(e) => {
        handleInputChange(e.target.checked);
        setLocalValue(e.target.checked);
      }}
      disabled={disabled}
    />
  );
}
